import { Link } from "react-router-dom";
import "./AboutSection.css";

export default function PremiumFooter() {
  return (
    <footer className="premium-footer">
      <div className="footer-glow footer-glow-1"></div>
      <div className="footer-glow footer-glow-2"></div>

      <div className="footer-top footer-top--expanded">
        <div className="footer-brand">
          <div className="footer-logo">
            <span>TH</span>
          </div>

          <div>
            <h2>Techio Hisab</h2>
            <p>
              Smart business operations platform built for modern teams,
              analytics, inventory, and scalable workflows.
            </p>
          </div>
        </div>

        <div className="footer-surface-grid">
          <article className="footer-surface-card footer-surface-card--wide">
            <h4>Built for modern operators</h4>
            <p>
              Clean visibility, premium spacing, and a focused workflow layer
              help teams move faster with less friction.
            </p>
          </article>

          <article className="footer-surface-card">
            <h4>Light on clutter</h4>
            <p>Everything stays readable, calm, and easy to scan.</p>
          </article>

          <article className="footer-surface-card">
            <h4>Always responsive</h4>
            <p>Designed to hold its shape across desktop, tablet, and mobile.</p>
          </article>
        </div>

        <div className="footer-links-wrapper">
          <div className="footer-links">
            <h4>Company</h4>
            <Link to="/about">About</Link>
            <Link to="/features">Features</Link>
            <Link to="/workflow">Workflow</Link>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-copy">
          <p>2026 Techio Hisab. All rights reserved.</p>
        </div>
<div className="footer-credit">
  Crafted with precision by{" "}
  <a
    href="https://3brotech.in/"
    target="_blank"
    rel="noopener noreferrer"
    className="footer-credit-link"
  >
    3brotech.in
  </a>
</div>
      </div>
    </footer>
  );
}
